<cigna-leaf-heading
  style="text-align: center"
  type="headline-large"
  [brandColor]="true"
  >Resources for Health Care Providers</cigna-leaf-heading
>
<div class="resource-grid cg-margin-top-xxl">
  <ng-container *ngFor="let resource of links">
    <div class="resource-item">
      <cigna-leaf-heading type="title-default" [brandColor]="true">{{
        resource.title
      }}</cigna-leaf-heading>
      <div class="cg-margin-top-sm" [innerHTML]="resource.body"></div>
      <div class="cg-margin-top-sm">
        <a
          *ngIf="resource.resourceContext !== 'external'"
          [href]="
            resource.url
              | resourceLink
                : {
                    secure: false,
                    type: resource.linkType,
                    targetApp: resource.resourceContext
                  }
              | async
          "
          target="resourcesWindow"
          [cignaTrackClicks]="[
            'trackEventOther',
            resource.urlName,
            'ac22398',
            {
              eVar120: 'login-resources-links',
              eVar119: 'US1881007'
            }
          ]"
          >{{ resource.urlName }}</a
        >
        <a
          *ngIf="resource.resourceContext === 'external'"
          [href]="resource.url"
          target="_blank"
          [cignaTrackClicks]="[
            'trackEventOther',
            resource.urlName,
            'ac22398',
            {
              eVar120: 'login-resources-links',
              eVar119: 'US1881007'
            }
          ]"
          >{{ resource.urlName }}</a
        >
      </div>
    </div>
  </ng-container>
  <ng-container *ngIf="verifyCoverageLink$ | async">
    <div class="resource-item" data-test="blk-resource-item">
      <cigna-leaf-heading
        data-test="hdr-coverage-network"
        type="title-default"
        [brandColor]="true"
        >Verify coverage and network status</cigna-leaf-heading
      >
      <div data-test="body-coverage-network" class="cg-margin-top-sm">
        Our Coverage Confirmation Grid lets you verify important patient
        information, including benefits and eligibility, prior authorization and
        EAP requirements, patient accumulation information and more.
      </div>
      <div class="cg-margin-top-sm">
        <a
          data-test="lnk-coverage-network"
          href="https://www.evernorth.com/provider-resources/verify-coverage"
          target="_blank"
          rel="noopener noreferrer"
          [cignaTrackClicks]="[
            'trackEventOther',
            'Verify coverage',
            'ac22398',
            {
              eVar120: 'login-resources-links',
              eVar119: 'US1881007'
            }
          ]"
          >Verify coverage</a
        >
      </div>
    </div>
  </ng-container>
</div>
